import { Grid } from 'components/layout';
import { LoadTextInput } from 'pages/LoadView/LoadInformation/Components';

export function CustomerSection() {
  return (
    <Grid cols='1' gap='md' className='w-full mx-0'>
      <LoadTextInput name='customer.name' label='Customer Name' readOnly />
      <LoadTextInput name='customer.city' label='City' readOnly />
      <LoadTextInput name='customer.state' label='State' readOnly />
      <LoadTextInput name='customer.zipCode' label='Zip' readOnly />
    </Grid>
  );
}
